import { Socket, connect as io } from "socket.io-client";
import { Middleware } from 'redux'
import {
    dashboardWSConnecting,
    dashboardWSDisconnecting,
    refreshData
} from './dashboardSlice';
import { IUpdateData } from "./types";

const chatMiddleware: Middleware = store => {
    let socket: Socket;
    return next => action => {
        const { user } = store.getState().auth;
        const url = process.env.REACT_APP_DASHBOARD_SOCKET ?? ""
        const domain = new URL(url)
        const pathname = "/wss/dashboard/";
        const cleandomain = `${domain.hostname}:${domain.port}`;;

        if (dashboardWSConnecting.match(action)) {
            try {
                if (domain && user?.deviceId) {
                    socket = io(cleandomain, {
                        path: pathname,
                        transports: ["websocket", "polling", "flashsocket"],
                    });
                    socket.on("update-data", (data: IUpdateData) => {
                        store.dispatch(refreshData(data));
                    });
                    socket.on("disconnect", () => {
                        console.log('disconnected dashboard');
                    });
                }
            } catch (err) {
                console.log(err);
            }
        }
        if (dashboardWSDisconnecting.match(action)) {
            if (socket)
                socket.disconnect();
        }

        next(action);

    }
}

export default chatMiddleware;
